import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { disciplineStyles } from "../../Assets/js/customStyles.js";


export default function RevaluationList() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const [discipline, setDisciplineChange] = useState(false);
  const [examid, setExamIdData] = useState(null);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [revaldata, setRevalData] = useState([]);
  const [loading, setlodaing] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [activeIndex, setActiveIndex] = useState([]);
  const [activeEvents, setActiveEvents] = useState([]);
  const [disciplineID, setDisciplineID] = useState([]);

  const { http } = Api();
  const handlExamChange = (selectedOption) => {
    if (selectedOption.value != examid) {
      setDisciplineData([]);
      setDisciplineChange(false);
      setRevalData([]);

    }

    setExamIdData(selectedOption.value);



  };

  const toggleRow = (index) => {
    setActiveIndex((prevActive) =>
      prevActive.includes(index)
        ? prevActive.filter((i) => i !== index)
        : [...prevActive, index]
    );
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`getActiveRevaluvations`);
        setExamData(response.data.activeexam);

      }
      catch (error) {
        if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  useEffect(() => {
    const getActiveEventForEcopy = () => {

      http.get('getActiveEvents', {
        params: {
          event_id: 13
        },
      }).then((response) => {
        //console.log("response",response)
        setActiveEvents(response.data);

      }).catch((error) => {
        if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
          toast.error(error.response.data.message);
        }
      });
    }
    getActiveEventForEcopy();

  }, [examid]);


  useEffect(() => {
    const fetchDisciplineData = () => {

      http.get(`/College/getEcopyDisciplines`, {
        params: {
          examid: examid
        },
      }).then((response) => {
        setDisciplineData(response.data.result);

      }).catch((error) => {
        if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response?.data?.http_status === 500 && error.response.data.status_code === "ERR5") {
          toast.error(error.response.data.message);
        }
        setDisciplineData([]);
        setRevalData([]);
        setDisciplineChange(false);

      });
    }
    fetchDisciplineData();

  }, [examid]);

  const getEcopyDetails = (selectedOption) => {
    setDisciplineChange(selectedOption);
    setDisciplineID(selectedOption.did);

    http.get(`/College/getEcopyDetailes`, {
      params: {
        college_course_type: selectedOption.type,
        discipline_id: selectedOption.did,
        examid: examid
      },
    }).then((response) => {

      setRevalData(response.data.result);

      setActiveIndex(Array.from({ length: Object.keys(response.data.result).length }, (_, i) => i))

    }).catch((error) => {
      if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      }
      else {
        toast.error("Data not found");
      }
    });

  }

  const updateStatus = (item, accountid, course_id) => {


    http.get(`/College/UpdateEcopyStatus`, {
      params: {
        item: item,
        account_id: accountid,
        course_id: course_id
      },
    }).then((response) => {

      if (discipline) {
        getEcopyDetails(discipline);
      }
      toast.success("Updated successfully");

    }).catch((error) => {
      if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      }
    });

  }
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const handleGeneratePDF = async (examid) => {
    // setLoading(true);
    try {
      const response = await http.get('/College/getcopyAnswerscriptExamwise', {
        params: {
          examid: examid,
          discipline_id:disciplineID
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    }
    catch (error) {
      //console.log("error=", error);
      //console.error('Full error response:', error.response);

      // Check if `error.response.data` is a Blob (which means we need to parse it)
      if (error.response?.data instanceof Blob) {
        error.response.data.text().then((text) => {
          try {
            const jsonData = JSON.parse(text);


            if (jsonData.http_status === 401 && jsonData.status_code == "ERR9") {
              toast.error("Invalid Token");
              setTimeout(() => {
                navigate("/college/");
              }, 5000);
            }
            else if (jsonData.http_status === 500 && jsonData.status_code == "ERR47") {
              toast.error(jsonData.message);
            }
            else if (jsonData.http_status === 400 && String(jsonData.status_code) === "ERR42") {

              toast.error(jsonData.message);
            }
            else {

              toast.error('Error generating PDF');
            }
          } catch (parseError) {
            //console.error('Error parsing Blob:', parseError);
            toast.error('Error generating PDF');
          }
        });
      }
      // If data is already a JSON object, process it directly
      else if (error.response?.data) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
          toast.error(error.response.data.message);
        }
        else if (error.response?.status === 400 && String(error.response?.data?.status_code) === "ERR42") {

          toast.error(error.response.data.message);
        }
        else {

          toast.error('Error generating PDF');
        }
      }
      else {

        toast.error('Error generating PDF');
      }
    }

  };


  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (

          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (

          <div className="container-fluid" >
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>Answer script e-copy requests by students</h5>
                      </div>

                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="table-responsive">
                          <div className="form theme-form">
                            <div className="card-body custom-input">
                              <div className="row">
                                <div className="col-md-6">
                                  <label>Examination <span className="errorclr">*</span></label>

                                  <Select
                                    styles={customStyles}
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="exam_id"
                                    name="exam_id"
                                    className="basic-select"
                                    classNamePrefix="select"
                                    options={getexamData.map(exam => ({
                                      value: exam.examid,
                                      label: exam.examtitle
                                    }))}
                                    onChange={handlExamChange}
                                    placeholder="Select an exam..."

                                    value={getexamData
                                      .filter(exam => exam.examid.toString() === examid ? examid.toString() : '')
                                      .map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))[0]}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label>Discipline<span className="errorclr">*</span></label>
                                  <Select
                                    styles={disciplineStyles}
                                    maxMenuHeight={500}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    onChange={getEcopyDetails}
                                    options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                      ? disciplinedata.map(discipline => ({
                                        did: discipline.id,
                                        value: discipline.discipline_name,
                                        label: discipline.discipline_name,
                                        type: discipline.college_course_type
                                      }))
                                      : [{ value: '0', label: 'No data found' }]
                                    }
                                    value={discipline}
                                    placeholder="Select Discipline"
                                  />
                                </div>
                              </div>
                              <div className="table-container" style={{ minHeight: '500px' }}>
                                <div className="buttons-container nav-right">
                                  {discipline && revaldata && Object.keys(revaldata).length > 0 && (
                                    <button
                                      className="lbl2 btn btn-primary mt-3 mb-3"
                                      onClick={() => handleGeneratePDF(examid)}
                                      title="Download"
                                    >
                                      <i class="bi bi-arrow-down-square"></i>
                                    </button>
                                  )}
                                </div>
                                {discipline && (
                                  <div className="txt-aln m-b-30 text-danger">
                                    {(() => {
                                      if (!activeEvents || activeEvents.length === 0) {
                                        return null;
                                      }

                                      const matchingEvent = activeEvents.find(
                                        (event) =>
                                          event.exam_id == examid &&
                                          event.status === "active" &&
                                          new Date() >= new Date(event.start_date) &&
                                          new Date() <= new Date(event.end_date)
                                      );

                                      return (
                                        <>

                                          {revaldata && Object.keys(revaldata).length > 0 && (
                                            <>
                                              Note:- E-copy processing&nbsp;
                                              {matchingEvent
                                                ? `is active until ${new Date(matchingEvent.end_date).toLocaleString()}. The actions are currently active.`
                                                : "is closed, no actions are possible."}
                                            </>
                                          )}

                                        </>
                                      );
                                    })()}
                                  </div>
                                )}

                                {revaldata && Object.keys(revaldata).length > 0 ?
                                  (<table className="table ex-table">
                                    <thead>
                                      <tr style={{ textAlign: "center", verticalAlign: "middle" }} >
                                        <th className="bg-light bg-gradient" width="10%">SL No.</th>
                                        <th className="bg-light bg-gradient" style={{ textAlign: "left" }}>
                                          Student Details
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {Object.entries(revaldata).map(([studentId, courses], index) => (
                                        <React.Fragment key={studentId}>
                                          <tr style={{ textAlign: "center", verticalAlign: "middle" }} className='th-fnt'>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: "left" }}>
                                              <b>{courses[0].PRN} - {courses[0].studentname}</b>
                                              <span style={{ marginLeft: "5px", cursor: "pointer", }} onClick={() => toggleRow(index)}>

                                                {activeIndex.includes(index) ? (
                                                  <p style={{ display: "inline", margin: "0", color: "#f44336", fontWeight: "bold", fontSize: "12px" }}>Hide</p>

                                                ) : (
                                                  <p style={{ display: "inline", margin: "0", color: "#008ce0", fontWeight: "bold", fontSize: "12px" }}>Show</p>
                                                )}
                                                <span style={{ marginLeft: "2px", fontSize: "18px", verticalAlign: "middle" }}>
                                                  {activeIndex.includes(index) ? (
                                                    <i className="bi bi-chevron-up" style={{ color: "#f44336" }}></i>
                                                  ) : (
                                                    <i className="bi bi-chevron-down" style={{ color: "#008ce0" }}></i>
                                                  )}
                                                </span>
                                              </span>
                                            </td>
                                          </tr>

                                          {activeIndex.includes(index) && (
                                            <tr>
                                              <td></td>
                                              <td colSpan="">
                                                <table className="table ex-table2">
                                                  <thead>
                                                    <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                      <th className="bg-primary">Course</th>
                                                      <th className="bg-primary">status</th>
                                                      <th className="bg-primary" width="25%">Action</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {courses.map((course, courseIndex) => (
                                                      <tr key={courseIndex} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                        <td style={{ textAlign: "left" }}>
                                                          {`${course.course_code} - ${course.course_name}`}
                                                          <span style={{ color: "green" , marginLeft: "5px" }}>
                                                            {course.false_number ? `(False No: ${course.false_number})` : '-'}
                                                          </span>
                                                        </td>
                                                        <td className="text-center">
                                                          {course.status === "verified" ? (
                                                            <span className="badge rounded-pill bg-warning">Ready for Despatch</span>
                                                          ) : course.status === "despatched" ? (
                                                            <span className="badge rounded-pill bg-success">Despatched</span>
                                                          ) : (
                                                            <span >-</span>
                                                          )}
                                                        </td>
                                                        {(() => {

                                                          //const examDetails = getexamData.find(item => item.examid === examid);

                                                          //if (!examDetails) return null;
                                                          if (!activeEvents || activeEvents.length === 0) {
                                                            return null;
                                                          }

                                                          const matchingEvent = activeEvents.find(
                                                            (event) =>
                                                              event.exam_id == examid &&
                                                              event.status === "active" &&
                                                              new Date() >= new Date(event.start_date) &&
                                                              new Date() <= new Date(event.end_date)
                                                          );

                                                          if (course.status === "verified" && matchingEvent) {
                                                            return (
                                                              <td>
                                                                <button
                                                                  className="btn btn-success btn-sm custom-hover-verify bt-wt"
                                                                  title="Despatch"

                                                                  onClick={() => updateStatus("despatched", course.accountid, course.course_id)}
                                                                >
                                                                  <i className="bi bi-truck me-1"></i>
                                                                  Despatch
                                                                </button>
                                                              </td>
                                                            );
                                                          }

                                                          if (course.status === "despatched" && matchingEvent) {
                                                            return (
                                                              <td>
                                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                  <i className="bi bi-check-circle-fill text-success fs-5"></i>
                                                                </div>
                                                                Despatched
                                                              </td>
                                                            );
                                                          }

                                                          if (course.status === null && matchingEvent) {
                                                            return (
                                                              <td>

                                                                <button
                                                                  className="btn btn-success btn-sm custom-hover-verify "
                                                                  title="Verify"
                                                                  style={{ width: '150px', fontSize: '0.8rem', padding: '2px' }}
                                                                  onClick={() => updateStatus("verified", course.accountid, course.course_id)}
                                                                >
                                                                  <i className="bi bi-check-circle me-1"></i> Ready for Despatch

                                                                </button>
                                                              </td>
                                                            );
                                                          }

                                                          return <td></td>;
                                                        })()}

                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                  ) : (
                                    <div className="text-center p-4">
                                      <i style={{ color: "red" }} className="bi bi-info-circle me-2"></i>
                                      No data available
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        )}

      </Template>
    </>
  );
}